import { render, staticRenderFns } from "./CategoryHeader.vue?vue&type=template&id=a341544a&scoped=true&"
import script from "./CategoryHeader.vue?vue&type=script&lang=ts&"
export * from "./CategoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryHeader.vue?vue&type=style&index=0&id=a341544a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a341544a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a341544a', component.options)
    } else {
      api.reload('a341544a', component.options)
    }
    module.hot.accept("./CategoryHeader.vue?vue&type=template&id=a341544a&scoped=true&", function () {
      api.rerender('a341544a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CategoryHeader.vue"
export default component.exports